import React from 'react';
import RTPageLayout from '../common/RTPageLayout';
import Tile from '../common/Tile';
import RequireMenuAccess from '../common/RequireMenuAccess';
import { useNavigate, useLocation } from 'react-router-dom';
import '../common/rtCommon.css';
import '../common/Tile.css';


const BedAllocationManagement = () => {
    const tiles = [
        {
            title: 'Allocate Bed',
            permissionKey: 'bedmanagement.allocate_bed',
            url: 'allocate-bed',
            icon: '🛏️',
            description: 'Assign a bed to a paying guest.',
        },
        {
            title: 'Move Bed',
            permissionKey: 'bedmanagement.move_bed',
            url: 'move-bed',
            icon: '🔄',
            description: 'Transfer a paying guest to another bed.',
        },
        {
            title: 'View Vacant Beds',
            permissionKey: 'bedmanagement.view_vacant_beds',
            url: 'view-vacant-beds',
            icon: '🏠',
            description: 'Check all beds that are currently vacant.',
        },
        {
            title: 'View Allocated Beds',
            permissionKey: 'bedmanagement.view_allocated_beds',
            url: 'view-allocated-beds',
            icon: '👤',
            description: 'See all beds currently allocated to paying guests.',
        },
        {
            title: 'View Soon Vacating Beds',
            permissionKey: 'bedmanagement.view_soon_vacating',
            url: 'view-soon-vacating-beds',
            icon: '⏰',
            description: 'See beds that will be vacated in the next 30 days.',
        },
        {
            title: 'View Allocation History',
            permissionKey: 'bedmanagement.view_allocation_history',
            url: 'view-allocation-history',
            icon: '📋',
            description: 'View beds that were allocated in the past.',
        },
        {
            title: 'Bed Pricing',
            permissionKey: 'bedmanagement.bed_pricing',
            url: 'bed-pricing',
            icon: '💰',
            description: 'View pricing details for different bed types and sharing options.',
        }
    ];
    const navigate = useNavigate();
    const location = useLocation();

    return (
        <RequireMenuAccess>
            <RTPageLayout
                title="Bed Allocation"
                mainSection
                activePath={location.pathname}
            >
                <div className="rt-tiles-grid">
                    {tiles.map((tile, idx) => (
                        <Tile
                            key={idx}
                            icon={tile.icon}
                            title={tile.title}
                            description={tile.description}
                            permissionKey={tile.permissionKey}
                            onClick={() => tile.url && navigate(tile.url)}
                            tabIndex={0}
                            role="button"
                            onKeyPress={(e) => {
                                if (e.key === 'Enter' && tile.url) navigate(tile.url);
                            }}
                        />
                    ))}
                </div>
            </RTPageLayout>
        </RequireMenuAccess>
    );
};

export default BedAllocationManagement;
